<template>
<div id="product-detail-page">
  <div class="body" :style="{opacity: firstLoaded ? 1 : 0}">
    <div class="product-box">
      <template v-if="product">
        <product-info :product="product" :from="from" :province_code="province_code"></product-info>
        <div class="product-right-fixed" :style="{transform: `translateY(${wxaQrcodeTranslateY}px)`}">
<!-- 
          <chatvisa-entrance-float
            :visa_country_id="product.visa_country_id"
            :sensor-data="{
              visa_country_id: product.visa_country_id,
              source: '商详页',
              visa_product_id: product.visa_product_id,
              product_name: product.product_name,
              country: product.visa_country_name
            }"
          ></chatvisa-entrance-float> -->

          <!-- 右侧二维码浮窗 -->
          <peer-to-wxa
            v-if="User.isLogin()"
            :visa-product-id="product.visa_product_id"
            :province_code="province_code"
          >
          </peer-to-wxa>
        </div>

      </template>
      <div class="none-products" v-else>
        <img src="../../assets/imgs/product-detail/nodata-product.png">
        <span class="none-product-text" >暂无数据</span>
      </div>
    </div>
  </div>

  <!-- 商品弹出弹窗 -->
  <product-popup-dialog ref="productPopupDialog"></product-popup-dialog>

  <!-- cs/bd弹窗 -->
  <product-exclusive-service-dialog ref="productExclusiveServiceDialog"></product-exclusive-service-dialog>

</div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import sensorsdata from 'sa-sdk-javascript';
import { ENTER_PRODUCT_DETAIL } from '../../maps/sensors-maps';
import User from '../../libs/user';
import Http from '../../libs/http';
import productInfo from './product-info/product-info';
import peerToWxa from './product-info/components/peer-to-wxa';
import ProductPopupDialog from './product-info/components/product-popup-dialog.vue';
import browserService from '../../services/browser-service';
import ChatvisaEntranceFloat from '../chat-visa/component-external/chatvisa-entrance-float.vue';
import productExclusiveServiceDialog from './components/product-exclusive-service-dialog';

export default {
  components: {
    productInfo,
    peerToWxa,
    ProductPopupDialog,
    ChatvisaEntranceFloat,
    productExclusiveServiceDialog,
  },
  data() {
    return {
      User,
      visa_product_id: 0,
      // 上面都是国家列表的数据
      product: null,
      wxaQrcodeTranslateY: 0, // 用来处理foot部分挡住问题
      countryTranslateY: false, // 用来处理foot部分挡住问题
      showEmbassyHoliday: false,
      firstLoaded: false,
      scrollLeft: 0, // 页面横向滚动条滚动距离
      from: '', // 来源，用于后端埋点
      province_code: 0, // 省份
    };
  },
  computed: {
    ...mapState('user', [
      'ipAddress',
      'peerCSData',
      'peerData',
    ]),
  },
  created() {
    if (!+this.$route.query.visa_product_id) {
      this.$router.replace({ path: '/' });
      return;
    }
    this.loadPageData().finally(() => {
      this.$refs.productExclusiveServiceDialog && this.$refs.productExclusiveServiceDialog.init();
    });
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {},
  methods: {
    ...mapActions('user', ['getPeerCSData', 'visaPeerQuery']),
    async loadPageData() {
      // 把URL部分的参数赋值一下
      this.visa_product_id = +this.$route.query.visa_product_id || 0;
      this.from = this.$route.query.from || '';
      this.province_code = +this.$route.query.province_code || 0;

      if (!this.visa_product_id) return;

      // 只有商品id，获取完商品信息后选择当前商品信息的国家
      await this.getProductDetail();
      const countryName = this.product ? this.product.visa_country_name : '';

      browserService.setHtmlSeo({
        keywords: `上上签,签证办理,${countryName}签证,查询签证资料清单,办理条件,办理流程,办理费用`,
        description: `上上签是国内领先的签证办理平台，为同业提供专业全球签证办理。上上签提供${countryName}签证办理，包括个人签证、旅游签证、商务签证、探亲访友签等签证类型，还可查询${countryName}领馆假期、${countryName}签证资料清单、${countryName}签证办理条件、${countryName}签证办理费用、${countryName}签证出行日期`,
      });

      this.loadPageDataSuccess();
      // 初始化弹出弹窗
      this.$refs.productPopupDialog.initPopupDialog();
    },
    loadPageDataSuccess() {
      // 第一次加载商品信息和国家信息成功后处理函数，主要用来处理异常情况
      // 1、商品已下架，2、商品在右边国家列表找不到。
      this.firstLoaded = true;
    },
    // 请求商品详情新接口
    getProductDetail() {
      let url = '';
      if (!User.isLogin()) {
        url = '/sys/visa_product_query';
      } else {
        url = '/visa_product_query';
      }
      return Http.post(url, {
        visa_product_id: this.visa_product_id,
      }).then((data) => {
        if (User.isLogin()) {
          Http.post('/xbb_record_add', { visa_product_id: this.visa_product_id, record_type: 1 });
        }

        // 工单埋点
        this.workOrderRecord();

        this.product = data;
        this.sensorDataLog(data);
      });
    },
    // 工单埋点
    workOrderRecord() {
      // 销帮帮记录埋点
      if (User.isLogin()) {
        Http.post('/peer_behavior_record_add', {
          visa_product_id: this.visa_product_id, // 签证产品id,  behavior_type_id = 10002:浏览商详页/10007:分享商详页必填
          behavior_type_id: 10002, // 10001:浏览商品列表页, 10002:浏览商详页, 10003:添加申请人, 10007:分享商详页, 10008:分享店铺
        });
      }
    },

    // 神策埋点
    async sensorDataLog(product) {
      if (User.isLogin()) {
        await this.getPeerCSData();
        await this.visaPeerQuery();
      }
      sensorsdata.track('EnterProductDetail', {
        ProductDetail_source: ENTER_PRODUCT_DETAIL[this.from] || this.from,
        page_from: this.$route.query ? this.$route.query.page_from : '', // 页面路径
        order_bd: this.peerData ? this.peerData.bd_name : '', // 归属BD
        country: product.visa_country_name,
        visa_product_id: product.visa_product_id,
        product_name: product.product_name,
        visa_type: product.visa_type,
        peer_name: User.peer.peer_name,
        user_type: '同业',
        need_online_application: Boolean(product.visa_application && product.visa_application.visa_application_id),
        need_interview: Boolean(product.need_interview || product.need_delivery),
        customer_service: (this.peerCSData && this.peerCSData.cs_name) || '',
      });
    },

    handleScroll() {

      const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
      this.scrollLeft = scrollLeft;

      const productTop = document.querySelector('.product-box').getBoundingClientRect().top;
      const productHeight = document.querySelector('.product-box').getBoundingClientRect().height;

      // 左侧商品的底部距离屏幕的距离
      const productLastTop = productTop + productHeight;

      // 处理右侧小程序码滚动问题
      const wxaQrcodeEl = document.querySelector('.product-right-fixed');
      if (wxaQrcodeEl) {
        const wxaQrcodeTop = wxaQrcodeEl.offsetTop;
        const wxaQrcodeHeight = wxaQrcodeEl.offsetHeight;
        // 右侧小程序码的底部距离屏幕的距离，如果大于国家的高度，则国家需要往上偏移
        if (wxaQrcodeTop + wxaQrcodeHeight > productLastTop) {
          this.wxaQrcodeTranslateY = productLastTop - (wxaQrcodeTop + wxaQrcodeHeight);
        } else {
          this.wxaQrcodeTranslateY = 0;
        }
      }

    },
  },
};
</script>
<style lang="less" scoped>
#product-detail-page {
  width: 1120px;
  margin: 0 auto;
  padding: 16px 0 60px 0;
  .body{
    display: flex;
    .product-box {
      flex-shrink: 0;
      width: 100%;
      position: relative;
      &::after{
        content: "";
        position: fixed;
        right: 0;
        top: 68px;
        width: 100%;
        height: 16px;
        z-index: 10;
        background: #F3F6F9;
      }
      .none-products {
        height: 605px;
        display: flex;
        flex-direction: column;
        padding-top: 74px;
        align-items: center;
        background:white;
        width:100%;
        box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);
        img {
          width: 200px;
          height: 132px;
        }
        .none-product-text {
          margin-top: 16px;
          font-size: 16px;
          color: #91999F;
        }
      }
      .product-right-fixed{
        position: fixed;
        // z-index: 10003;
        width: 106px;
        bottom: 16px;
        // 让浮窗位置固定在离主体内容区右侧外面 20px 的位置
        // 主体内容区宽度 1000px，浮窗宽度 106px，浮窗距离左侧主体内容区 20px
        right: calc(~'(100% - 1120px) / 2 - 126px');
        // right: 10px;
        z-index: 1005;
        display: flex;
        flex-direction: column;
        align-items: center;
        .peer-to-wxa {
          margin-top: 20px;
        }
      }

    }

  }
}


/* 媒体查询：当屏幕宽度小于 1500px 时，隐藏目标元素 */
@media (max-width: 1499px) {
  #product-detail-page {
    .body {
      .product-right-fixed {
        visibility: hidden;
        opacity: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/Product.vue